import React, { useEffect, useState } from 'react';
import api from '../api';
import Layout from '../components/Layout';

export default function Partidos() {
  const [partidos, setPartidos] = useState([]);
  const [modal, setModal] = useState(null);
  const [form, setForm] = useState({ nome:'', sigla:'', numero:'', email_contato:'', plano:'profissional', subdominio:'' });
  const [msg, setMsg] = useState('');

  const carregar = () => api.get('/partidos').then(r => setPartidos(r.data)).catch(() => {});
  useEffect(() => { carregar(); }, []);

  const salvar = async () => {
    try {
      if (modal === 'novo') await api.post('/partidos', form);
      else await api.put(`/partidos/${modal.id}`, form);
      setMsg('Salvo!'); setModal(null); carregar();
    } catch(e) { setMsg(e.response?.data?.erro || 'Erro'); }
  };

  return (
    <Layout title="Partidos clientes">
      {msg && <div style={s.msg}>{msg} <button onClick={() => setMsg('')} style={s.close}>×</button></div>}
      <div style={s.bar}>
        <p style={s.desc}>Cada partido é um ambiente isolado. Usuários de um partido não veem dados de outro.</p>
        <button style={s.btn} onClick={() => { setForm({nome:'',sigla:'',numero:'',email_contato:'',plano:'profissional',subdominio:''}); setModal('novo'); }}>+ Novo partido</button>
      </div>
      <div style={s.grid}>
        {partidos.map(p => (
          <div key={p.id} style={s.card}>
            <div style={s.cardTop}>
              <div style={s.num}>{p.numero}</div>
              <div>
                <div style={s.pnome}>{p.nome}</div>
                <div style={s.psub}>{p.subdominio}.asscamp.app</div>
              </div>
              <span style={{...s.plano, background: p.plano==='enterprise'?'#EEEDFE':p.plano==='profissional'?'#E1F5EE':'#F1EFE8'}}>{p.plano}</span>
            </div>
            <div style={s.cardStats}>
              <span>👥 {p.total_usuarios || 0} usuários</span>
              <span style={{...s.ativo, color: p.ativo ? '#3B6D11' : '#A32D2D'}}>{p.ativo ? '● Ativo' : '● Inativo'}</span>
            </div>
            <div style={s.cardActs}>
              <button style={s.abtn} onClick={() => { setForm({nome:p.nome,sigla:p.sigla,numero:p.numero,email_contato:p.email_contato,plano:p.plano,ativo:p.ativo,subdominio:p.subdominio}); setModal(p); }}>✏️ Editar</button>
            </div>
          </div>
        ))}
      </div>
      {modal && (
        <div style={s.overlay}>
          <div style={s.modal}>
            <h3 style={s.mtitle}>{modal==='novo' ? 'Novo partido cliente' : 'Editar partido'}</h3>
            <div style={s.frow}>
              <div style={s.field}><label>Nome</label><input style={s.input} value={form.nome} onChange={e => setForm({...form,nome:e.target.value})} /></div>
              <div style={s.field}><label>Sigla</label><input style={s.input} value={form.sigla} onChange={e => setForm({...form,sigla:e.target.value})} /></div>
            </div>
            <div style={s.frow}>
              <div style={s.field}><label>Número</label><input style={s.input} type="number" value={form.numero} onChange={e => setForm({...form,numero:e.target.value})} /></div>
              <div style={s.field}><label>Subdomínio</label><input style={s.input} value={form.subdominio} onChange={e => setForm({...form,subdominio:e.target.value})} placeholder="ex: pl" /></div>
            </div>
            <div style={s.field}><label>E-mail de contato</label><input style={s.input} type="email" value={form.email_contato} onChange={e => setForm({...form,email_contato:e.target.value})} /></div>
            <div style={s.field}><label>Plano</label>
              <select style={s.input} value={form.plano} onChange={e => setForm({...form,plano:e.target.value})}>
                <option value="basico">Básico</option>
                <option value="profissional">Profissional</option>
                <option value="enterprise">Enterprise</option>
              </select>
            </div>
            <div style={s.mfoot}>
              <button style={s.cbtn} onClick={() => setModal(null)}>Cancelar</button>
              <button style={s.btn} onClick={salvar}>Salvar</button>
            </div>
          </div>
        </div>
      )}
    </Layout>
  );
}

const s = {
  msg:{background:'#EAF3DE',color:'#3B6D11',padding:'10px 16px',borderRadius:8,marginBottom:16,display:'flex',justifyContent:'space-between'},
  close:{background:'none',border:'none',cursor:'pointer',fontSize:18},
  bar:{display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:20},
  desc:{fontSize:13,color:'#666',margin:0},
  btn:{background:'#534AB7',color:'#fff',border:'none',borderRadius:8,padding:'9px 18px',fontSize:13,fontWeight:600,cursor:'pointer'},
  grid:{display:'grid',gridTemplateColumns:'repeat(auto-fill,minmax(280px,1fr))',gap:16},
  card:{background:'#fff',borderRadius:12,padding:20,boxShadow:'0 1px 4px rgba(0,0,0,0.06)'},
  cardTop:{display:'flex',alignItems:'center',gap:12,marginBottom:12},
  num:{width:40,height:40,borderRadius:8,background:'#E6F1FB',color:'#185FA5',display:'flex',alignItems:'center',justifyContent:'center',fontWeight:700,fontSize:15},
  pnome:{fontWeight:600,color:'#1a1a2e',fontSize:14},
  psub:{fontSize:11,color:'#534AB7',marginTop:2},
  plano:{fontSize:10,padding:'2px 8px',borderRadius:20,fontWeight:500,marginLeft:'auto'},
  cardStats:{display:'flex',justifyContent:'space-between',fontSize:12,color:'#888',marginBottom:12},
  ativo:{fontWeight:500},
  cardActs:{display:'flex',gap:8},
  abtn:{background:'#f8f9fa',border:'1px solid #eee',borderRadius:6,padding:'5px 12px',cursor:'pointer',fontSize:12},
  overlay:{position:'fixed',inset:0,background:'rgba(0,0,0,0.4)',display:'flex',alignItems:'center',justifyContent:'center',zIndex:100},
  modal:{background:'#fff',borderRadius:16,padding:28,width:420},
  mtitle:{margin:'0 0 20px',fontSize:16,fontWeight:600},
  frow:{display:'grid',gridTemplateColumns:'1fr 1fr',gap:12},
  field:{display:'flex',flexDirection:'column',gap:6,marginBottom:14},
  input:{padding:'9px 12px',border:'1px solid #ddd',borderRadius:8,fontSize:13},
  mfoot:{display:'flex',justifyContent:'flex-end',gap:10,marginTop:20},
  cbtn:{background:'#f0f0f0',border:'none',borderRadius:8,padding:'9px 18px',fontSize:13,cursor:'pointer'},
};
